import { LegalPage, type LegalSection } from './LegalPage';

const SECTIONS: LegalSection[] = [
  {
    heading: 'Who we are',
    body: [
      'Possignin is a cloud point-of-sale and business management service operated by ITCity, based in Sylhet, Bangladesh. This policy explains what we collect, why, and the choices you have.',
      'It applies to the Possignin SaaS app and the Possignin POS, whether you use Possignin directly or through one of our resellers.',
    ],
  },
  {
    heading: 'What we collect',
    body: [
      'Account data: your name, email or username, phone number, and password (stored only as a hash — we never store your plain password).',
      'Business data you enter: products, customers, suppliers, staff, sales, invoices, and reports for your business.',
      'Payment data: when you pay a subscription, our gateway SSLCommerz processes the card or mobile-wallet details. We receive only the result (paid / failed) and a reference — never your full card number.',
      'Technical data: IP address, device and browser type, and basic usage logs, used to keep the service secure and working.',
    ],
  },
  {
    heading: 'How we use it',
    body: [
      'To run the service: process your sales, keep your subscription active, and show your reports.',
      'To support you: answer questions and fix problems you report.',
      'To keep things safe: detect fraud, abuse, and security issues, and meet our legal obligations.',
      'We do not use your business data to train advertising models, and we never sell it.',
    ],
  },
  {
    heading: 'Where your data lives',
    body: [
      'Your operational data is stored in a database for your business, hosted on our infrastructure in Bangladesh. New businesses can be given a dedicated database; some are hosted on your own server if you choose the self-hosted option.',
      'We keep nightly backups and use encryption in transit (HTTPS) for everything between your browser and our servers.',
    ],
  },
  {
    heading: 'Sharing',
    body: [
      'We share data only with: SSLCommerz (to take payments), and a reseller — if you signed up under one — limited to what they need to manage your account.',
      'We may disclose data if required by Bangladeshi law or a valid legal request. We will tell you when we are allowed to.',
    ],
  },
  {
    heading: 'Your choices',
    body: [
      'You can access and export your business data at any time from inside the app.',
      'You can ask us to delete your account and data; we will do so within 30 days, except where we must keep records for legal or accounting reasons.',
      'You can turn off non-essential cookies — see our Cookie Policy.',
    ],
  },
  {
    heading: 'Changes & contact',
    body: [
      'We may update this policy; we will post the new version here and update the date above. Material changes will be notified in the app.',
      'For any privacy question, email support@itcitysoft.com.',
    ],
  },
];

export function Privacy() {
  return (
    <LegalPage
      title="Privacy Policy"
      updated="14 June 2026"
      intro="Your business data is yours. This policy explains, in plain terms, what Possignin collects, how we use it, and the control you keep."
      sections={SECTIONS}
    />
  );
}
